import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { ethers } from 'ethers'
import { W3config } from '../../../../configs/config'
import ContractInterface  from './../../../../configs/staking_ci.json'
import TokenABI from './../../../../configs/t8_ci.json'

// http://localhost:1337/api/users/me?populate[wallets][populate][0]=package

const host = process.env.REACT_APP_HOST_URL

export const getUserProCal = createAsyncThunk('dashboard/getWalletReferrals', async (data) => {
    try {
        const userData = JSON.parse(localStorage.getItem('userData'))
        const response = await axios.get(`${host}/api/cal-pro-com?id=${data.wallet_id}`, {
            headers: {
                Authorization: `Bearer ${userData.token}`
            }
        })
        console.log(response)
        return response.data

    } catch (e) {
        console.log(e)
    }
})

export const getUserTokenBalance = createAsyncThunk('dashboard/getUserTokenBalance', async ({provider, isConnected, address}) => {
    try {
        let balance = 0
        if (isConnected) {
            const contract = new ethers.Contract(W3config.T8_CONTRACT_ADDRESS, TokenABI, provider)
            balance = await contract.balanceOf(address)
            balance = ethers.utils.formatUnits(balance, 8)
            console.log(balance)
        }
        return balance
    } catch (e) {
        console.log(e)
    }
})


export const getUserWalletPackage = createAsyncThunk('dashboard/getUserWalletPackage', async({provider, isConnected, address}, {dispatch, getState}) => {
    try {
        const userData = JSON.parse(localStorage.getItem('userData'))
        const response = await axios.get(`${host}/api/users/me?populate[wallets][populate][0]=package`, {
            headers: {
                Authorization: `Bearer ${userData.token}`
            }
        })
        if (response.data && response.data.wallets.length > 0 && response.data.wallets.package !== null) {
            const contract = new ethers.Contract(W3config.STAKING_CONTRACT_ADDRESS, ContractInterface, provider)
            
            if (!isConnected) {
                await dispatch(getUserProCal({wallet_id: response.data.wallets[0].id}))
            } else {
                const selectedWallet = response.data.wallets.filter(item => item.wallet_address.toLowerCase() === address.toLowerCase())
                console.log(selectedWallet)
                if (selectedWallet[0].wallet_address.toLowerCase() === address.toLowerCase()) {
                    await dispatch(getUserProCal({wallet_id: selectedWallet[0].id}))
                    response.data.wallets = selectedWallet
                }
            }
        }
        return response.data
    } catch (e) {
        console.log(e)
    }
})

export const updateWalletBalance = createAsyncThunk('dashboard/updateWalletBalance', async ({id, amount, provider, isConnected, address}, {dispatch, getState}) => {
    try {
        const userData = JSON.parse(localStorage.getItem('userData'))
        const response = await axios.put(`${host}/api/wallets/${id}`, {
            data: {
                balance: amount
            }
        }, {
            headers: {
                Authorization: `Bearer ${userData.token}`
            }
        })
        await dispatch(getUserWalletPackage({provider, isConnected, address}))
    } catch (e) {
        console.log(e)
    }
})


export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState: {
        data: null,
        referrals: [],
        tokenBalance: null
    }, 
    reducers:{
       
    }, 
    extraReducers: builder => {
        builder 
            .addCase(getUserWalletPackage.fulfilled, (state, action) => {
                state.data = action.payload
            })
            .addCase(getUserProCal.fulfilled, (state, action) => {
                state.referrals = action.payload
            })
            .addCase(getUserTokenBalance.fulfilled, (state, action) => {
                console.log(action)
                state.tokenBalance = action.payload
            })
    }
})

export default dashboardSlice.reducer